import { render, staticRenderFns } from "./DepositoDentalListado.vue?vue&type=template&id=93465840"
import script from "./DepositoDentalListado.vue?vue&type=script&lang=js"
export * from "./DepositoDentalListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports